module.exports = __webpack_public_path__ + "static/media/Quicksand-Regular.316c2321.ttf";